import React, { useId } from 'react';
import styles from './Spinner.module.css';

interface SpinnerProps {
  size?: number;
  text?: string;
  className?: string;
  label?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({
  size = 40,
  text,
  className,
  label,
}) => {
  const reactId = useId();
  const gradientId = `spinner-gradient-${reactId.replace(/:/g, '')}`;
  const compact = size <= 24;
  const statusLabel = text || label || 'Loading';

  return (
    <div
      className={`${styles.root}${className ? ` ${className}` : ''}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={statusLabel}
    >
      <span
        className={`${styles.mark}${compact ? ` ${styles.compact}` : ''}`}
        style={{ width: size, height: size }}
        aria-hidden="true"
      >
        <span className={styles.halo} />
        <svg className={styles.svg} viewBox="0 0 48 48">
          <defs>
            <linearGradient id={gradientId} x1="8" y1="6" x2="40" y2="42" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="#93c5fd" />
              <stop offset="48%" stopColor="#3b82f6" />
              <stop offset="100%" stopColor="#1d4ed8" />
            </linearGradient>
          </defs>
          <circle className={styles.track} cx="24" cy="24" r="18" />
          <circle className={styles.arc} cx="24" cy="24" r="18" stroke={`url(#${gradientId})`} />
          <circle className={styles.spark} cx="24" cy="24" r="18" />
        </svg>
        <span className={styles.core} />
      </span>
      {text ? <span className={styles.text}>{text}</span> : null}
    </div>
  );
};

export default Spinner;
